import { render, staticRenderFns } from "./sitegatewayshealth.vue?vue&type=template&id=9da91dbe&scoped=true"
import script from "./sitegatewayshealth.vue?vue&type=script&lang=js"
export * from "./sitegatewayshealth.vue?vue&type=script&lang=js"
import style0 from "./sitegatewayshealth.vue?vue&type=style&index=0&id=9da91dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da91dbe",
  null
  
)

export default component.exports